import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'lib-flexible'
import i18n from './i18n'
Vue.config.productionTip = false
// utils/rem.js 或 main.js 中
function setRem() {
  // 基于 1920px 设计稿，分成 10 等份
  const baseSize = 192; // 1920 / 10 = 192
  const scale = document.documentElement.clientWidth / 1920;
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
}

// 初始化
setRem();
// 窗口变化时重置
window.addEventListener('resize', setRem);
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
